import React from 'react';
import { ReactComponent as LatestIcon } from 'resources/images/latest-solid.svg';
import { ListItemText } from 'app/components/ChakraTableList';
import { useAppSelector } from 'app/store';
import { getPlayerCurrentAudio } from 'app/store/AudioPlayer/selectors';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { getAudioTitleSx } from './styles';

interface AudioTitleProps {
  title: string;
  audioGuid?: string;
  playlistAudioGuid?: string;
  isLatestVersion: boolean;
  isPlayerTheme?: boolean;
}

export const AudioTitle: React.FC<AudioTitleProps> = ({
  title,
  audioGuid,
  playlistAudioGuid,
  isLatestVersion,
  isPlayerTheme = false,
}) => {
  const currentAudio = useAppSelector(getPlayerCurrentAudio);
  const guid = playlistAudioGuid || audioGuid;
  const activeGuid = currentAudio?.playlistAudioGuid || currentAudio?.audioGuid;
  const isActive = Boolean(guid && guid === activeGuid);
  const styles = getAudioTitleSx(isActive, isPlayerTheme);
  const Title = <Text data-testid="audio-title">{title}</Text>;

  return (
    <ListItemText
      title={title}
      primary={
        <>
          {isLatestVersion ? (
            <Flex gap={1}>
              {Title}
              <Icon
                as={LatestIcon}
                data-testid="latest-version-icon"
                color="textBase"
                ml="2px"
                width="initial"
                height="initial"
              />
            </Flex>
          ) : (
            Title
          )}
        </>
      }
      primaryTextProps={{
        sx: styles.title,
      }}
    />
  );
};
